<template>
  <div class="l_app_setting_faq">
    <div class="container">
      <div class="content">
        <h3>簡単な設定でもっとお得に!</h3>
        <br>
        <p>位置情報などの設定を有効にしていただくと、お店に来るたびスタンプや特別なクーポンが手に入ってもっとお得に! </p>
        <br>
        <p style="color: #e03535">※ 有効にしていない場合、スタンプが受け取れません。 ! </p>
        <table class="accorditional" width="100%">
          <tr>
            <td>
              <h5>位置情報</h5>
              <p>「常に許可」を選択するとアプリを立ち上げなくても来店スタンプがゲットできます。</p>
            </td>
            <td width="150" class="text-center">
              <button>有効にする</button>
            </td>
          </tr>
          <tr>
            <td>
              <h5>Bluetooth</h5>
            </td>
            <td class="text-center">
              <button>有効にする</button>
            </td>
          </tr>
          <tr>
            <td>
              <h5>通知</h5>
              <p>「オン」にすると、スタンプゲットのお知らせや、お得なキャンペーン情報を受け取れます。</p>
            </td>
            <td class="text-center">
              <button>有効にする</button>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FAQAppSetting',
  created () {
    document.title = 'アプリ設定'
  },
  methods: {
    goBack: function () {
      this.$router.push({ name: 'FAQ' })
    }
  }
}
</script>

<style scoped>

.l_app_setting_faq {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;
}

.l_app_setting_faq .container .header {
  max-width: 100%;
  padding: 18px 0px;
  position: relative;
  border-bottom: 1px solid #eeeeee;
}

.l_app_setting_faq .container > img {
  max-width: 100%;
}
.l_app_setting_faq .container .header > img {
  position: absolute;
  left: 18px;
}

.l_app_setting_faq .container .header > p {
  font-family: HiraKakuPro-W6;
  font-size: 15px;
  font-weight: bold;
  line-height: 1;
  text-align: center;
}

.l_app_setting_faq h3, .l_app_setting_faq h4 {
  color: #602209;
}

.l_app_setting_faq .l_button__external {
  width: 250px;
  margin: 20px auto 0;
}
.l_app_setting_faq .content {
  background-color: #ffffff;
  text-align: left;
  padding: 20px;
}
.l_app_setting_faq .content hr {
  margin-top: 10px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 1px solid #efb90f;
}
.l_app_setting_faq .content img{
  margin-top: 20px;
  margin-bottom: 10px;
  max-width: 100%;
}
.l_app_setting_faq .content .accorditional {
  margin-top: 50px;
  border-bottom: 1px solid #dddddd;
}
.l_app_setting_faq .content .accorditional tr {
  box-shadow: inset 0 1px 0 0 #dddddd;
}
.l_app_setting_faq .content .accorditional td {
  vertical-align: middle;
  font-size: 11px;
  color: #777777;
  padding-top: 10px;
  padding-bottom: 10px;
}
.l_app_setting_faq .content .accorditional td h5 {
  font-size: 17px;
  font-weight: normal;
  color: #333333;
}
.l_app_setting_faq .content .accorditional td.text-center {
  text-align: center;
}
.l_app_setting_faq .content .accorditional button {
  border-radius: 15.5px;
  border: solid 1px #602209;
  color: #602209;
  font-weight: bold;
  font-size: 17px;
  padding: 5px 18px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  background: none;
}
</style>
